import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ISolicitudAmpliarPersonalModel } from 'src/app/models/interfaces/solicitud/ISolicitudAmpliarPersonalModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';

@Component({
  selector: 'app-solicitud-ampliar-personal',
  templateUrl: './solicitud-ampliar-personal.component.html',
  styleUrls: ['./solicitud-ampliar-personal.component.css']
})
export class SolicitudAmpliarPersonalComponent implements OnInit {
  
  constructor(
    public dialogRef: MatDialogRef<SolicitudAmpliarPersonalComponent>,
    private solicitudService: SolicitudService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public model: ISolicitudAmpliarPersonalModel
  ) { }

  ngOnInit(): void {
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.solicitudService.ampliarPersonal(this.model).subscribe((p) => {
        this.alertDialogService.open('Se generó la nueva solicitud para la ampliación de Personas, Equipos, Vehículos y/o Documentación Técnica.');
        this.dialogRef.close();
      });
    }
  }

  onNoClick(){
    this.dialogRef.close();
  }
}
